<template>
<div class="user-events">

  <page-header>
    <nav-inner :use-user-links="true"/>
  </page-header>
  <router-link
    class="help-link help-link_pcr"
    :to="{ path: '/help/25'}"
    target="_blank">
      Подробнее об уведомлениях в разделе Помощь
  </router-link>

  <div class="page-container">
    <template v-if="events && !loading">
      <div
        class="user-events-filter"
        v-if="eventTypesList">
        <el-select
          v-model="eventTypes"
          class="user-events-select"
          @change="onChangeFilter"
          multiple
          clearable
          placeholder="Выберите действие...">
          <el-option
            v-for="(type, i) in eventTypesList"
            :key="`opt-${i}`"
            :label="type.EventTitle"
            :value="type.EventId">
          </el-option>
        </el-select>
        <button
          :disabled="eventTypes.length === 0"
          class="vivid-button"
          @click="filterEvents">Применить</button>
      </div>

      <div
        class="user-event"
        v-for="(event, i) in events"
        :key="`user-event-${i}`">
        <div class="event-wrap">
          <div
            v-if="event.Score !== 0"
            class="score-status">
            {{ event.Score > 0 ? '+' : '' }} {{ event.Score }} балл
          </div>
          <div
            v-if="event.Reputation !== 0"
            class="reputation-status">
            {{ event.Reputation > 0 ? '+' : '' }} {{ event.Reputation }} к репутации
          </div>
          <div class="event-title">
            {{ event.EventTitle }}
          </div>
          <div class="event-info">
            <router-link
              v-if="event.ObjectId"
              class="object-link"
              :to="`/object/${event.ObjectId}`">
              {{ eventLinkTitle(event) }}
            </router-link>
            <div
              v-if="event.Message"
              class="event-message">
              {{ event.Message }}
            </div>
            <div class="event-created-time">
              Дата события: {{ eventTime(event.TimeStamp) }}
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        v-show="paginationVisible"
        :page-size="limit"
        :total="found"
        :current-page="currentPage"
        @current-change="currentChange"
        layout="prev, pager, next, jumper"/>
    </template>
    <template v-else-if="!loading">
      <div>
        События отсутствуют
      </div>
    </template>
  </div>

  <page-footer/>

</div>
</template>

<script>
import axios from 'axios';
import PageHeader from '../PageHeader';
import PageFooter from '../PageFooter';
import NavInner from '../NavInner';
import Misc from '../../mixins/Misc';

export default {

  mixins: [Misc],

  components: { PageHeader, PageFooter, NavInner },

  data() {
    return {
      events: [],
      paginationVisible: false,
      found: 1,
      offset: 0,
      currentPage: 1,
      loading: false,
      userId: '',
      limit: 20,
      eventTypes: [],
      eventTypesList: [],
    };
  },

  created() {
    axios.get('users/eventTypes').then((r) => {
      const blockedEvent = ['BLOCK_OBJECT', 'UNBLOCK_OBJECT', 'BLOCK_USER_OBJECT', 'UNBLOCK_USER_OBJECT'];
      r.data.forEach((event) => {
        if (blockedEvent.indexOf(event.EventId) === -1) {
          this.eventTypesList.push(event);
        }
      });
    }).catch(() => this.$notify.error(
      'Ошибка при загрузке списка действий пользователя.'));
    this.userId = this.$store.getters['user/getUserId'];
    this.fetchData();
  },

  watch: {
    $route() {
      this.fetchData();
    },
  },

  methods: {

    filterEvents() {
      this.fetchData(true);
    },

    onChangeFilter() {
      if (this.eventTypes.length === 0) {
        this.fetchData(true);
      }
    },

    fetchData(resetSearch = false) {
      this.loading = true;
      const query = {};
      query.limit = this.limit;
      query.type = 'all';
      if (this.$route.query.offset && !resetSearch) query.offset = this.$route.query.offset;
      if (this.eventTypes.length !== 0) query.events = this.eventTypes;
      axios.get(`/users/${this.userId}/events`, { params: query }).then((response) => {
        this.offset = typeof this.$route.query.offset !== 'undefined' ? this.$route.query.offset : 0;
        this.found = response.data.Found;
        this.paginationVisible = Math.floor((this.found - 1) / this.limit) > 0;
        this.currentPage = Math.floor(this.offset / this.limit) + 1;
        this.$nextTick(() => {
          this.events = response.data.UserEvents;
        });
        this.loading = false;
      });
    },

    currentChange(curPage) {
      const query = Object.assign({}, this.$route.query);
      query.offset = this.limit * (curPage - 1);
      this.$router.push({ path: this.$route.path, query });
      this.scrollTop();
    },

    eventTime(timeStamp) {
      let time = '';
      if (timeStamp) {
        const d = new Date(timeStamp * 1000);
        const year = d.getFullYear();

        let month = d.getMonth() + 1;
        if (month < 10) month = `0${month}`;

        let date = d.getDate();
        if (date < 10) date = `0${date}`;

        let hours = d.getHours();
        if (hours < 10) hours = `0${hours}`;

        let minutes = d.getMinutes();
        if (minutes < 10) minutes = `0${minutes}`;

        time = `${date}.${month}.${year} ${hours}:${minutes}`;
      }
      return time;
    },

    eventLinkTitle(event) {
      if (event.ObjectTitle) return event.ObjectTitle;
      return event.ObjectId;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input__inner {
  background-color:#fff;
}
.user-events {
  .page-container {
    max-width: 1250px;
    width: 100%;
    padding: 0 25px;
    margin: 0 auto;
    .user-events-filter {
      text-align: center;
      margin-top: 20px;
      padding: 20px;
      -webkit-box-shadow: 0 1px 12px rgba(0, 0, 0, 0.15);
      box-shadow: 0 1px 12px rgba(0, 0, 0, 0.15);
      border-radius: 10px;
      .vivid-button {
        margin-top: 10px;
        &:disabled {
          cursor: default;
        }
      }
    }
    .user-event {
      -webkit-box-shadow: 0 1px 12px rgba(0, 0, 0, 0.15);
      box-shadow: 0 1px 12px rgba(0, 0, 0, 0.15);
      margin: 20px 0;
      padding: 30px 30px 25px;
      border-radius: 10px;
      min-height: 55px;
      position: relative;
      overflow: hidden;
      .event-wrap {
        position: relative;
        padding-right: 220px;
        .score-status,
        .reputation-status {
          padding-right: 20px;
          display: inline-block;
          color: #bd4e9b;
        }
        .event-info {
          .object-link {
            text-decoration: underline;
          }
          .event-created-time {
            color: #aaa;
          }
        }
        .event-title {
          font-size: 18px;
          line-height: 20px;
          padding: 0;
          font-weight: normal;
        }
      }
    }
  }
}
.theme-b {
    .user-event,
    .user-events-filter {
      background: #1a1a1a;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/UserEvents.vue